import * as types from './constants';
const initialState = {
    loading: false,
    dataSupervisor: [],
}

const UserSupervisor = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_DATA_SUPERVISOR:
        {
            return {...state, dataSupervisor: action.payload, loading: action.loading }
        }
        case types.RESET_LOADING:
            return {
                ...state,
                loading: false
        }
        case types.OPEN_NEW_DIALOG:
        {
            return {
                ...state,
                agentDialog: {
                    type : 'New',
                    props: {
                        open: true
                    },
                    data : null
                }
            };
        }
        case types.CLOSE_NEW_DIALOG:
        {
            return {
                ...state,
                agentDialog: {
                    type : 'New',
                    props: {
                        open: false
                    },
                    data : null
                }
            };
        }
        case types.SUBMIT_SUCCEED:
            return { ...state, showMessage: action.payload, error: null, loading: false }
        case types.SUBMIT_FAILED:
            return { ...state, showMessage: null, error: action.payload, loading: false }
        case types.RESET_MESSAGE:
            return { ...state, showMessage: null, error: null }
        case types.FILTER_SUPERVISOR:
            return { ...state, loading: true }
        case types.LOAD_SUPERVISOR_BY_FILTER:
            return { ...state, loading: false, dataSupervisor: action.payload }
        case types.EDIT_SUPERVISOR:
            return { ...state, loading: true }
        case types.DELETE_SUPERVISOR:
            return { ...state, loading: true }
        default:
            return { ...state };
    }
}

export default UserSupervisor;